import { Helpers } from "../../../../helpers/Helpers";
import { GetAntrepoOutByIdResponseData } from "../../../../models/response/antrepoOut/GetAntrepoOutByIdResponse";
import { KTCard } from "../../../../_metronic/helpers/components/KTCard";
import { KTCardBody } from "../../../../_metronic/helpers/components/KTCardBody";
import { GetAntrepoInByIdResponseData } from "../../../../models/response/antrepoIn/GetAntrepoInByIdResponse";

interface Props {
    redreseAntrepoInRef: any
    redreseAntrepoIn: GetAntrepoInByIdResponseData[]
}

const RedreseAntrepoIn = ({
    redreseAntrepoInRef,
    redreseAntrepoIn
}: Props) => {
    return (
        <div className='containerPart' ref={redreseAntrepoInRef}>
            <KTCard className="ebbe-card mt-10">
                <KTCardBody>
                    <h4 className="mb-10 text-black">Bağlı Redreseli İşlem</h4>

                    <div className="row mt-5">
                        <div className="col-md-12">
                            <div className='table-responsive'>
                                <table id='kt_table_users' className='table align-middle table-row-dashed dataTable no-footer'>
                                    <thead>
                                        <tr className='text-start text-muted fw-bolder text-uppercase'>
                                            <th>Redreseli Antrepo Beyan No</th>
                                            <th>Redreseli Antrepo Beyan Tarihi</th>
                                            <th>Redrese Beyan Kap Adet</th>
                                            <th>Redrese Beyan Kap Ağırlık (Kg)</th>
                                        </tr>
                                    </thead>
                                    <tbody className='text-gray-600 fw-bold'>
                                        {
                                            redreseAntrepoIn.map((item, index) =>
                                                <tr>
                                                    <td><a onClick={() => window.open(window.location.href.split('=')[0] + "=" + item.antrepoInId, "_blank")} href='javascript:;'>{item.antrepoDeclarationNo}</a></td>
                                                    <td>{Helpers.dateParser(item.antrepoDeclarationDate, true)}</td>
                                                    <td>{item.declarationPotQuantity}</td>
                                                    <td>{item.declarationPotWeight}</td>
                                                </tr>
                                            )
                                        }
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </KTCardBody>
            </KTCard>
        </div>
    )
}

export default RedreseAntrepoIn;